import React from 'react';
import {Form, Modal} from "react-bootstrap";
import {Controller, useForm} from 'react-hook-form';
import LoadingButtonWithForm from '../../components/LoadingButtonWithForm';
import {useAddBrokerMutation, useEditBrokerMutation} from "../../redux/services/BrokerService";
import {sweetAlert} from "../../utils";
import {responseError} from "../../helpers/responseHandler";
import PhoneInput from "react-phone-input-2";

const AddCompanyModal = ({isEdit, show, handleClose}) => {
    let {
        control,
        register,
        handleSubmit,
        setValue,
        watch,
        reset,
        formState: {errors},
    } = useForm()

    const [addRequest, {isLoading: addLoading}] = useAddBrokerMutation()
    const [editRequest, {isLoading: editLoading}] = useEditBrokerMutation()

    const onSubmit = async (data) => {
        if (isEdit) {
            const newForm = {...data}
            await editRequest({id: isEdit?.id, newForm}).unwrap()
                .then((res) => {
                    if (res?.status) {
                        sweetAlert(res?.message, 'success')
                        // navigate(-1)
                        handleClose()
                    }
                })
                .catch((err) => {
                    responseError(err)
                })
        } else {
            const newForm = {...data}
            await addRequest(newForm).unwrap()
                .then((res) => {
                    if (res?.status) {
                        sweetAlert(res?.message, 'success')
                        // navigate(-1)
                        handleClose()
                    }
                })
                .catch((err) => {
                    responseError(err)
                })
        }
    }

    return (
        <>
            <Modal show={show} size="lg" onHide={handleClose}>
                <Modal.Header className="border-0" closeButton>
                    <Modal.Title className="h5">{isEdit ? 'Edit' : 'Add'} Broker Company</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form onSubmit={handleSubmit(onSubmit)} id='broker-status'>
                        <div className="row">
                            <div className="col-md-12">
                                <Form.Group className="mb-3">
                                    <Form.Label>Broker Name:</Form.Label>
                                    <Controller
                                        name="broker_name"
                                        control={control}
                                        defaultValue={isEdit?.broker_name || ''}
                                        rules={{
                                            required: true
                                        }}
                                        render={({field}) => (
                                            <Form.Control
                                                {...field}
                                                type="text"
                                                placeholder="Enter broker name"
                                                isInvalid={errors?.broker_name}
                                            />
                                        )}
                                    />

                                </Form.Group>
                            </div>
                            <div className="col-md-12">
                                <Form.Group className="mb-3">
                                    <Form.Label>Broker Email:</Form.Label>
                                    <Controller
                                        name="broker_email"
                                        control={control}
                                        defaultValue={isEdit?.broker_email || ''}
                                        rules={{
                                            required: true
                                        }}
                                        render={({field}) => (
                                            <Form.Control
                                                {...field}
                                                type="email"
                                                placeholder="Enter broker email"
                                                isInvalid={errors?.broker_email}
                                            />
                                        )}
                                    />
                                </Form.Group>
                            </div>
                            <div className="col-md-12">
                                <Form.Group className="mb-3">
                                    <Form.Label>Phone Number:</Form.Label>
                                    <Controller
                                        name="phone_number"
                                        control={control}
                                        defaultValue={isEdit?.phone_number || ''}
                                        rules={{
                                            required: false
                                        }}
                                        render={({field}) => (
                                            <div className={`${errors?.broker_number ? 'border border-danger' : ''}`}>
                                                <PhoneInput
                                                    {...field}
                                                    country={'us'} // Default country
                                                    inputProps={{
                                                        name: 'phone_number',
                                                        required: true,
                                                        autoFocus: true,
                                                    }}
                                                />
                                            </div>
                                        )}
                                    />
                                </Form.Group>
                            </div>
                            <div className="col-md-12">
                                <Form.Group className="mb-3">
                                    <Form.Label>Description:</Form.Label>
                                    <Controller
                                        name="description"
                                        control={control}
                                        defaultValue={isEdit?.description || ''}
                                        rules={{
                                            required: false
                                        }}
                                        render={({field}) => (
                                            <Form.Control
                                                {...field}
                                                as="textarea" rows={3}
                                                placeholder="Enter description"
                                                isInvalid={errors.description}
                                            />
                                        )}
                                    />
                                </Form.Group>
                            </div>
                        </div>
                    </Form>
                </Modal.Body>
                <Modal.Footer className="border-0">
                    <LoadingButtonWithForm
                        isLoading={editLoading ? editLoading : addLoading}
                        name="Save"
                        form="broker-status"
                    />
                </Modal.Footer>

            </Modal>
        </>
    );
};

export default AddCompanyModal;